import React from 'react'
import { useState } from "react";
import { useDispatch } from 'react-redux';
import "../chatAiComponents/ChatAii.css";
import SettingUser from './SettingUser';
import SettingToken from './SettingToken';
// import LeftMenu from '../chatAiComponents/LeftMenu';
// import ChatEngageMeeting from './ChatEngageMeeting';
import CustomFields from './CustomFields';
import { Fragment} from 'react'
import { Dialog, Transition } from '@headlessui/react'
import {
  Bars3Icon,
  XMarkIcon,
} from '@heroicons/react/24/outline'

import { Receipt, Bell, People, Sliders, Calendar3, UsbSymbol, Calendar2Check, Person, Palette, ChatSquareText } from "react-bootstrap-icons";
import Sidebar from './Sidebar';
import AddUser from './AddUser';
import SettingAccount from './SettingAccount';
import SettingBilling from './SettingBilling';
import SettingNotification from './SettingNotification';
import SettingCalendly from './SettingCalendly';
import SettingCalender from './SettingCalender';
import SettingEvents from './SettingEvents';
import SettingEventList from './SettingEventList';
import SettingConnect from './SettingConnect';
import SettingHubspot from './SettingHubspot';
import SettingSyncField from './SettingSyncField';
import SettingHubspotMapping from './SettingHubspotMapping';
import SettingSyncedHubspot from './SettingSyncedHubspot';
import SettingProfile from './SettingProfile';
import SettingCalendarSelect from './SettingCalendarSelect';
import SettingAdvanceIntent from './SettingAdvanceIntent';
import SettingPaymentHistory from './SettingPaymentHistory';
import SettingBillingCalculator from './SettingBillingCalculator';
import SettingSiaSetup from './SettingSiaSetup';
import SettingRecommendedQuestions from './SettingRecommendedQuestions';
// import ChatSettings from './ChatSettings';

const SettingContainer = (props) => {
  const dispatch = useDispatch();
  // const operation_mode = useSelector((state) => state.chatAi.operation_mode);
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const userType = localStorage.getItem("userType")
    ? localStorage.getItem("userType")
    : ""; 
  const navigation = [
    // { name: 'Users', href: '/Setting', icon: People, current: "user" , nav_name: "user, editUser, addUser" },
    { name: 'Setup', href: '/Setting/setup', icon: Palette, current: "setup" , nav_name: "setup" },
    { name: 'Recommended Questions', href: '/Setting/recommendedQuestions', icon: ChatSquareText, current: "recommendedQuestions" , nav_name: "recommendedQuestions" },
    // { name: 'User Profile', href: '/Setting/profile', icon: Person, current: "profile" , nav_name: "profile" },
    // { name: 'General', href: '/Setting/account', icon: Sliders, current: "account" , nav_name: "account" },
    // { name: 'Plans & Billing', href: '/Setting/billing', icon: Receipt, current: "billing" , nav_name: "billing" },
    // { name: 'Appointment', href: '/Setting/selectCalendar', icon: Calendar2Check, current: "selectCalendar" , nav_name: "calender, connect, events, eventSetting,selectCalendar" },
    // { name: 'Notification Center', href: '/Setting/notification', icon: Bell, current: "notification" , nav_name: "notification" },
    // { name: 'Calendly', href: '/Setting/calendly', icon: Calendar3, current: "calendly" , nav_name: "calendly" },
    // { name: 'Events', href: '/Setting/events', icon: Calendar, current: "events" },
    // { name: 'Hubspot', href: '/Setting/hubspot', icon: UsbSymbol, current: "hubspot", nav_name: "hubspot, syncFields, syncedHubspot, hubspotMapping" },
    // { name: 'Intel Setting', href: '/Setting/advanceIntent', icon: Bell, current: "advanceIntent" , nav_name: "advanceIntent" },
    // { name: 'Custom Field', href: '/Setting/fields', icon: ChartPieIcon, current: "fields" },
  ]
  const navigationNew = [
    { name: 'User Profile', href: '/Setting/profile', icon: People, current: "profile" , nav_name: "profile" },
    // { name: 'Custom Field', href: '/Setting/fields', icon: ChartPieIcon, current: "fields" },
  ]

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }
  
  const RightScreen = () => {
    if (props.subPageName === "user") {
      return <SettingUser authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if (props.subPageName === "token") {
      return <SettingToken authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if (props.subPageName === "addUser") {
      return <AddUser authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if (props.subPageName === "editUser") {
      return <AddUser authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if (props.subPageName === "fields") {
      return <CustomFields authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if (props.subPageName === "notification") {
      return <SettingNotification authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if (props.subPageName === "advanceIntent") {
      return <SettingAdvanceIntent authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if (props.subPageName === "account") {
      return <SettingAccount authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if(props.subPageName === "billing") {
      return <SettingBilling authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if(props.subPageName === "billingCalculate") {
      return <SettingBillingCalculator authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if(props.subPageName === "calendly") {
      return <SettingCalendly authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if(props.subPageName === "calender") {
      return <SettingCalender authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if(props.subPageName === "eventSetting") {
      return <SettingEvents authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    } 
    else if (props.subPageName === "events") {
      return <SettingEventList authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if (props.subPageName === "connect") {
      return <SettingConnect authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName} />
    }
    else if (props.subPageName === "hubspot") {
      return <SettingHubspot authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if(props.subPageName === "syncFields") {
      return <SettingSyncField authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if(props.subPageName === "hubspotMapping") {
      return <SettingHubspotMapping authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if(props.subPageName === "syncedHubspot") {
      return <SettingSyncedHubspot authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if(props.subPageName === "profile") {
      return <SettingProfile authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if(props.subPageName === "selectCalendar") {
      return <SettingCalendarSelect authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if(props.subPageName === "paymentHistory") {
      return <SettingPaymentHistory authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if (props.subPageName === "setup") {
      return <SettingSiaSetup authToken={props.authToken} />
    }
    else if (props.subPageName === "recommendedQuestions") {
      return <SettingRecommendedQuestions authToken={props.authToken} />
    }
    else {
      return
    }
  }

  return (
    <>
      <div className='h-full'>
        <Transition.Root show={sidebarOpen} as={Fragment}>
          <Dialog as="div" className="relative z-50 lg:hidden" onClose={setSidebarOpen}>
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-900/80" />
            </Transition.Child>

            <div className="fixed inset-0 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="relative mr-16 flex w-full max-w-xs flex-1">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                      <button type="button" className="-m-2.5 p-2.5" onClick={() => setSidebarOpen(false)}>
                        <span className="sr-only">Close sidebar</span>
                        <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
                      </button>
                    </div>
                  </Transition.Child>
                  {/* Sidebar component, swap this element with another sidebar if you like */}
                  <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4">
                    <div className="flex h-16 shrink-0 items-center">
                    <div className='text-base font-[600] py-4 '>Train AI</div>
                    </div>
                    <nav className="flex flex-1 flex-col">
                      <ul role="list" className="flex flex-1 flex-col gap-y-7">
                        <li>
                          <ul role="list" className="-mx-2 space-y-1">
                            {navigation.map((item) => (
                              <li key={item.name}>
                                <span
                                  href={item.href}
                                  className={classNames(
                                    props.subPageName === item.current
                                      ? 'bg-gray-50 text-[var(--brand-primary)]'
                                      : 'text-[var(--brand-secondary)] hover:text-[var(--brand-primary)] hover:bg-gray-50',
                                    'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                                  )}
                                >
                                  <item.icon
                                    className={classNames(
                                      props.subPageName === item.current ? 'text-[var(--brand-primary)]' : 'text-gray-400 group-hover:text-[var(--brand-primary)]',
                                      'h-6 w-6 shrink-0'
                                    )}
                                    aria-hidden="true"
                                  />
                                  {item.name}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </li>
                        {/* <li>
                          <div className="text-xs font-semibold leading-6 text-gray-400">Your teams</div>
                        </li> */}
                      </ul>
                    </nav>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>
        {/* Static sidebar for desktop */}
        <Sidebar subPageName={props.subPageName} navigation={userType=== "4" ? navigationNew : navigation}/>
        {/* Static sidebar for mobile */}
        <div className="lg:pl-72">
          <div className="sm:hidden hidden sticky top-0 z-40 h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
            <button type="button" className="-m-2.5 p-2.5 text-[var(--brand-secondary)] lg:hidden" onClick={() => setSidebarOpen(true)}>
              <span className="sr-only">Open sidebar</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
            {/* Separator */}
          </div>
          <main className="pt-[5rem] pb-10 h-[100vh] bg-[#F3F4F6] border-l border-gray-200">
            <div className={(props.subPageName !== "calender" && props.subPageName !== "events" && props.subPageName !== "connect" && props.subPageName !== "eventSetting") && "px-6 sm:px-8 lg:px-10"}>
              <RightScreen pageName={props.pageName} subPageName={props.subPageName} authToken={ props.authToken } />
            </div>
          </main>
        </div>
      </div>
    </>
  )
}

export default SettingContainer
